import { connect } from 'react-redux';
import React, { useState } from 'react';
import {
  retrieveSimplifiedEmployees,
  selectRetrieveSimplifiedEmployeesState,
  selectSimplifiedEmployees,
} from '../../modules/employees.js';
import ComboboxEmployee from '../ComboboxEmployee.jsx';

const blockStyle = {
  border: '1px solid #DFE2E5',
  borderRadius: '3px',
};

const mapDispatchToProps = { retrieveSimplifiedEmployees };
const mapStateToProps = (state) => ({
  employees: selectSimplifiedEmployees(state),
  pending: selectRetrieveSimplifiedEmployeesState(state).pending,
});

const EmployeesAutocomplete = ({
  multiple,
  isItemActive,
  retrieveSimplifiedEmployees,
  handleSelect,
  additionalSearchParams,
}) => {
  const [entities, setEntities] = useState([]);

  const isDisabled = (id) => false;

  const isActive = (id) => (isItemActive ? isItemActive(id) : false);
  // const isDisabled = (id) => isItemDisabled ? isItemDisabled(id) : false;

  const onInputValueChange = async (inputValue) => {
    const noResult = [{ id: 'no-result', fullName: 'No Result' }];
    if (inputValue.length < 2) {
      setEntities(noResult);
    } else {
      setEntities([]);
      try {
        const response = await retrieveSimplifiedEmployees({
          ...additionalSearchParams,
          search: inputValue,
          autocomplete: true,
          page: inputValue.length === 2 ? 1 : null,
          perPage: inputValue.length === 2 ? 100 : null,
        });

        const { employees } = response;

        if (employees && employees.length) {
          setEntities(employees);
        } else {
          setEntities(noResult);
        }
      } catch (error) {
        console.error(error);
      }
    }
  };

  const onSelectedItemChange = (selectedItem) => {
    if (selectedItem.id === 'no-result') {
      return null;
    }
    handleSelect(selectedItem);
  };

  return (
    <div style={blockStyle}>
      <ComboboxEmployee
        entities={entities}
        onInputValueChange={onInputValueChange}
        onSelectedItemChange={onSelectedItemChange}
        isActive={isActive}
        multiple={multiple}
      />
    </div>
  );
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(EmployeesAutocomplete);
